import React from 'react';

function HomePage() {


    return (
        <div>
            Siema
        </div>
    );
}



export default HomePage
